

// Generated class FilterTicketLine_ManagedObject

class FilterTicketLine_ManagedObject extends MIOManagedObject
{
}
